import { createFileRoute, redirect } from '@tanstack/react-router'

/**
 * The old combined page. It showed platform and tenant-owned credential groups
 * in one list; the platform's admin has always split them, so it now lands on
 * the platform side. Kept as a redirect so links already handed out resolve.
 */
export const Route = createFileRoute('/_shell/credential-groups')({
  beforeLoad: () => {
    throw redirect({ to: '/check-rate' })
  },
})
